// source: sync.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.EncryptedData', null, global);
goog.exportSymbol('proto.Message', null, global);
goog.exportSymbol('proto.MessageEnvelope', null, global);
goog.exportSymbol('proto.SyncRequest', null, global);
goog.exportSymbol('proto.SyncResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EncryptedData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.EncryptedData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.EncryptedData.displayName = 'proto.EncryptedData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Message = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Message.displayName = 'proto.Message';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MessageEnvelope = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MessageEnvelope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MessageEnvelope.displayName = 'proto.MessageEnvelope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SyncRequest = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.SyncRequest.repeatedFields_,
    null,
  );
};
goog.inherits(proto.SyncRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SyncRequest.displayName = 'proto.SyncRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SyncResponse = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.SyncResponse.repeatedFields_,
    null,
  );
};
goog.inherits(proto.SyncResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SyncResponse.displayName = 'proto.SyncResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.EncryptedData.prototype.toObject = function (opt_includeInstance) {
    return proto.EncryptedData.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.EncryptedData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.EncryptedData.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        iv: msg.getIv_asB64(),
        authtag: msg.getAuthtag_asB64(),
        data: msg.getData_asB64(),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EncryptedData}
 */
proto.EncryptedData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.EncryptedData();
  return proto.EncryptedData.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EncryptedData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EncryptedData}
 */
proto.EncryptedData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setIv(value);
        break;
      case 2:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setAuthtag(value);
        break;
      case 3:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EncryptedData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.EncryptedData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EncryptedData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EncryptedData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIv_asU8();
  if (f.length > 0) {
    writer.writeBytes(1, f);
  }
  f = message.getAuthtag_asU8();
  if (f.length > 0) {
    writer.writeBytes(2, f);
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(3, f);
  }
};

/**
 * optional bytes iv = 1;
 * @return {!(string|Uint8Array)}
 */
proto.EncryptedData.prototype.getIv = function () {
  return /** @type {!(string|Uint8Array)} */ (
    jspb.Message.getFieldWithDefault(this, 1, '')
  );
};

/**
 * optional bytes iv = 1;
 * This is a type-conversion wrapper around `getIv()`
 * @return {string}
 */
proto.EncryptedData.prototype.getIv_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getIv()));
};

/**
 * optional bytes iv = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getIv()`
 * @return {!Uint8Array}
 */
proto.EncryptedData.prototype.getIv_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getIv()));
};

/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedData} returns this
 */
proto.EncryptedData.prototype.setIv = function (value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};

/**
 * optional bytes authTag = 2;
 * @return {!(string|Uint8Array)}
 */
proto.EncryptedData.prototype.getAuthtag = function () {
  return /** @type {!(string|Uint8Array)} */ (
    jspb.Message.getFieldWithDefault(this, 2, '')
  );
};

/**
 * optional bytes authTag = 2;
 * This is a type-conversion wrapper around `getAuthtag()`
 * @return {string}
 */
proto.EncryptedData.prototype.getAuthtag_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getAuthtag()));
};

/**
 * optional bytes authTag = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAuthtag()`
 * @return {!Uint8Array}
 */
proto.EncryptedData.prototype.getAuthtag_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getAuthtag()));
};

/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedData} returns this
 */
proto.EncryptedData.prototype.setAuthtag = function (value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};

/**
 * optional bytes data = 3;
 * @return {!(string|Uint8Array)}
 */
proto.EncryptedData.prototype.getData = function () {
  return /** @type {!(string|Uint8Array)} */ (
    jspb.Message.getFieldWithDefault(this, 3, '')
  );
};

/**
 * optional bytes data = 3;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.EncryptedData.prototype.getData_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getData()));
};

/**
 * optional bytes data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.EncryptedData.prototype.getData_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getData()));
};

/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedData} returns this
 */
proto.EncryptedData.prototype.setData = function (value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Message.prototype.toObject = function (opt_includeInstance) {
    return proto.Message.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Message} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Message.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dataset: jspb.Message.getFieldWithDefault(msg, 1, ''),
        row: jspb.Message.getFieldWithDefault(msg, 2, ''),
        column: jspb.Message.getFieldWithDefault(msg, 3, ''),
        value: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Message}
 */
proto.Message.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Message();
  return proto.Message.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Message}
 */
proto.Message.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setDataset(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRow(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setColumn(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Message.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Message.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDataset();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getRow();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getColumn();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional string dataset = 1;
 * @return {string}
 */
proto.Message.prototype.getDataset = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.Message} returns this
 */
proto.Message.prototype.setDataset = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string row = 2;
 * @return {string}
 */
proto.Message.prototype.getRow = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.Message} returns this
 */
proto.Message.prototype.setRow = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string column = 3;
 * @return {string}
 */
proto.Message.prototype.getColumn = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.Message} returns this
 */
proto.Message.prototype.setColumn = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string value = 4;
 * @return {string}
 */
proto.Message.prototype.getValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.Message} returns this
 */
proto.Message.prototype.setValue = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.MessageEnvelope.prototype.toObject = function (opt_includeInstance) {
    return proto.MessageEnvelope.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.MessageEnvelope} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.MessageEnvelope.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        timestamp: jspb.Message.getFieldWithDefault(msg, 1, ''),
        isencrypted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
        content: msg.getContent_asB64(),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MessageEnvelope}
 */
proto.MessageEnvelope.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MessageEnvelope();
  return proto.MessageEnvelope.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MessageEnvelope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MessageEnvelope}
 */
proto.MessageEnvelope.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTimestamp(value);
        break;
      case 2:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsencrypted(value);
        break;
      case 3:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setContent(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MessageEnvelope.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.MessageEnvelope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MessageEnvelope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MessageEnvelope.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getIsencrypted();
  if (f) {
    writer.writeBool(2, f);
  }
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(3, f);
  }
};

/**
 * optional string timestamp = 1;
 * @return {string}
 */
proto.MessageEnvelope.prototype.getTimestamp = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.MessageEnvelope} returns this
 */
proto.MessageEnvelope.prototype.setTimestamp = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional bool isEncrypted = 2;
 * @return {boolean}
 */
proto.MessageEnvelope.prototype.getIsencrypted = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 2, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.MessageEnvelope} returns this
 */
proto.MessageEnvelope.prototype.setIsencrypted = function (value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};

/**
 * optional bytes content = 3;
 * @return {!(string|Uint8Array)}
 */
proto.MessageEnvelope.prototype.getContent = function () {
  return /** @type {!(string|Uint8Array)} */ (
    jspb.Message.getFieldWithDefault(this, 3, '')
  );
};

/**
 * optional bytes content = 3;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.MessageEnvelope.prototype.getContent_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getContent()));
};

/**
 * optional bytes content = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.MessageEnvelope.prototype.getContent_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getContent()));
};

/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.MessageEnvelope} returns this
 */
proto.MessageEnvelope.prototype.setContent = function (value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SyncRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.SyncRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.SyncRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.SyncRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.SyncRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        messagesList: jspb.Message.toObjectList(
          msg.getMessagesList(),
          proto.MessageEnvelope.toObject,
          includeInstance,
        ),
        fileid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        groupid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        keyid: jspb.Message.getFieldWithDefault(msg, 5, ''),
        since: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SyncRequest}
 */
proto.SyncRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SyncRequest();
  return proto.SyncRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SyncRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SyncRequest}
 */
proto.SyncRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.MessageEnvelope();
        reader.readMessage(
          value,
          proto.MessageEnvelope.deserializeBinaryFromReader,
        );
        msg.addMessages(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setFileid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setGroupid(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setKeyid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setSince(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SyncRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.SyncRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SyncRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SyncRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.MessageEnvelope.serializeBinaryToWriter,
    );
  }
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getKeyid();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getSince();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * repeated MessageEnvelope messages = 1;
 * @return {!Array<!proto.MessageEnvelope>}
 */
proto.SyncRequest.prototype.getMessagesList = function () {
  return /** @type{!Array<!proto.MessageEnvelope>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.MessageEnvelope, 1)
  );
};

/**
 * @param {!Array<!proto.MessageEnvelope>} value
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.setMessagesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.MessageEnvelope=} opt_value
 * @param {number=} opt_index
 * @return {!proto.MessageEnvelope}
 */
proto.SyncRequest.prototype.addMessages = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.MessageEnvelope,
    opt_index,
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.clearMessagesList = function () {
  return this.setMessagesList([]);
};

/**
 * optional string fileId = 2;
 * @return {string}
 */
proto.SyncRequest.prototype.getFileid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.setFileid = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string groupId = 3;
 * @return {string}
 */
proto.SyncRequest.prototype.getGroupid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.setGroupid = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string keyId = 5;
 * @return {string}
 */
proto.SyncRequest.prototype.getKeyid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.setKeyid = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string since = 6;
 * @return {string}
 */
proto.SyncRequest.prototype.getSince = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.SyncRequest} returns this
 */
proto.SyncRequest.prototype.setSince = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SyncResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.SyncResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.SyncResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.SyncResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.SyncResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        messagesList: jspb.Message.toObjectList(
          msg.getMessagesList(),
          proto.MessageEnvelope.toObject,
          includeInstance,
        ),
        merkle: jspb.Message.getFieldWithDefault(msg, 2, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SyncResponse}
 */
proto.SyncResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SyncResponse();
  return proto.SyncResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SyncResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SyncResponse}
 */
proto.SyncResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.MessageEnvelope();
        reader.readMessage(
          value,
          proto.MessageEnvelope.deserializeBinaryFromReader,
        );
        msg.addMessages(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setMerkle(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SyncResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.SyncResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SyncResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SyncResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.MessageEnvelope.serializeBinaryToWriter,
    );
  }
  f = message.getMerkle();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * repeated MessageEnvelope messages = 1;
 * @return {!Array<!proto.MessageEnvelope>}
 */
proto.SyncResponse.prototype.getMessagesList = function () {
  return /** @type{!Array<!proto.MessageEnvelope>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.MessageEnvelope, 1)
  );
};

/**
 * @param {!Array<!proto.MessageEnvelope>} value
 * @return {!proto.SyncResponse} returns this
 */
proto.SyncResponse.prototype.setMessagesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.MessageEnvelope=} opt_value
 * @param {number=} opt_index
 * @return {!proto.MessageEnvelope}
 */
proto.SyncResponse.prototype.addMessages = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.MessageEnvelope,
    opt_index,
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SyncResponse} returns this
 */
proto.SyncResponse.prototype.clearMessagesList = function () {
  return this.setMessagesList([]);
};

/**
 * optional string merkle = 2;
 * @return {string}
 */
proto.SyncResponse.prototype.getMerkle = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.SyncResponse} returns this
 */
proto.SyncResponse.prototype.setMerkle = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

goog.object.extend(exports, proto);
